import { FC, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { getFullNameFromFio } from 'helpers/string'
import { useTypedSelector } from 'src/hooks'
import { useUserInfoQuery } from 'src/modules/login/api'
import { UserInfo } from 'src/schema'

import { SUPPORT_SCRIPT_URL } from './constants'

export const UpdatedSupportChat = () => {
  const { token } = useTypedSelector((state) => state.authReducer)
  const { data: user } = useUserInfoQuery(undefined, { skip: !token })

  const [isVisible, setIsVisible] = useState(true)

  const handleReset = () => {
    setIsVisible(false)
    const scripts = document.querySelectorAll('#usedesk-messenger')
    Array.from(scripts).forEach((script) => script.remove())

    setTimeout(() => setIsVisible(true), 100)
  }

  useEffect(() => {
    handleReset()
  }, [user])

  return isVisible && <SupportChat user={user} />
}

export const SupportChat: FC<{ user: UserInfo | undefined }> = ({ user }) => {
  const subscribeToWidgetStore = useCallback(() => {
    const useDeskMessenger = window.usedeskMessenger

    if (!useDeskMessenger) {
      return
    }

    sessionStorage.removeItem('feedbackFormDefaultValues')
    useDeskMessenger.userIdentify({
      email: user?.email || '',
      phone: user?.phone || '',
      name: getFullNameFromFio({
        lastname: user?.lastname,
        firstname: user?.firstname,
        secondname: user?.secondname
      })
    })

    if (!useDeskMessenger?.store?.subscribe) {
      // eslint-disable-next-line no-console
      console.error(
        '%c Usedesk widget: %c Cant subscribe to useDesk store',
        'color: #fff; background: #000',
        'color: #fff; background: red'
      )

      return
    }

    useDeskMessenger.store.subscribe(() => {
      const wrapper = document.getElementById('usedesk-messenger')
      wrapper?.setAttribute('data-test', 'notification')
    })
  }, [])

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    window.__widgetInitCallback = () => {
      subscribeToWidgetStore()
    }
  }, [subscribeToWidgetStore])

  return (
    <Helmet>
      <script async src={SUPPORT_SCRIPT_URL} />
    </Helmet>
  )
}
